import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "This is Poker App!", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_info = _resolveComponent("header-info")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_card_screen = _resolveComponent("card-screen")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_card_input = _resolveComponent("card-input")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_footer_info = _resolveComponent("footer-info")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_header_info),
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_main, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              justify: "center",
              "margin-bottom": "24px"
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, {
              justify: "center",
              "align-content": "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "8",
                  md: "8",
                  lg: "8"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_card_screen)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, {
              justify: "center",
              class: "input"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "6",
                  md: "6",
                  lg: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_card_input, {
                      hand: _ctx.reactiveHand.hand
                    }, null, 8, ["hand"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_footer_info)
  ], 64))
}